import React, { memo } from 'react';
import Drawer from 'devextreme-react/drawer';
import ScrollView from 'devextreme-react/scroll-view';
import { Template } from 'devextreme-react/core/template';
import SideNavigationMenu from './SideNavigationMenu/SideNavigationMenu';

const NavDrawer = ({
  treeViewRef,
  compactMode,
  darkThemeEnabled,
  patchCssClass,
  onOutsideClick,
  isLarge,
  isXSmall,
  onNavigationChanged,
  temporaryOpenMenu,
  onMenuReady,
  scrollViewRef,
  navItems,
  children
}) => (
  <Drawer
    className={`${['drawer', patchCssClass].join(' ')} ${
      darkThemeEnabled ? 'main-drawer--dark' : ''
    }`}
    position="before"
    closeOnOutsideClick={onOutsideClick}
    openedStateMode={isLarge ? 'shrink' : 'overlap'}
    revealMode={isXSmall ? 'slide' : 'expand'}
    minSize={isXSmall ? 0 : 60}
    maxSize={250}
    opened={!compactMode}
    template="menu"
  >
    <div className="container">
      <ScrollView ref={scrollViewRef} className="layout-body with-footer">
        <div className="content">{children}</div>
      </ScrollView>
    </div>
    <Template name="menu">
      <SideNavigationMenu
        navItems={navItems}
        treeViewRef={treeViewRef}
        compactMode={compactMode}
        selectedItemChanged={onNavigationChanged}
        openMenu={temporaryOpenMenu}
        onMenuReady={onMenuReady}
      />
    </Template>
  </Drawer>
);

export default memo(NavDrawer);
